var materea_t=window.materea_t||(window.materea_t=function(k,v){var d=window.materea_texte;if(!d){try{d=JSON.parse(document.getElementById('materea-i18n').textContent)}catch(e){d={}}window.materea_texte=d}var s=d[k];if(s==null)return k;return v?s.replace(/\{(\w+)\}/g,function(m,n){return n in v?v[n]:m}):s});
(function(){
  if (window.__matereaWs) return;
  window.__matereaWs = 1;

  var p = new URLSearchParams(location.search);
  var statisch = p.get('static') === '1';
  var reduziert = matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (statisch) document.documentElement.classList.add('static');

  

  var ledger = document.querySelector('[data-materea-ledger]');
  if (ledger && !document.getElementById('termine')) {
    ledger.id = 'termine';
    ledger.style.scrollMarginTop = '1.5rem';
  }

  

  if (!statisch && !reduziert && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('anim');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:.2});
    document.querySelectorAll('.ws-sec').forEach(function(s){ io.observe(s); });
  }

  

  var sticky = document.querySelector('[data-ws-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var heroSichtbar = true, zielSichtbar = false;
    var setze = function(){
      sticky.classList.toggle('an', !heroSichtbar && !zielSichtbar);
    };
    var hero = document.querySelector('.ws1');
    if (hero) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){ heroSichtbar = e.isIntersecting; }); setze();
      }, {threshold:.1}).observe(hero);
    }
    var ziele = document.querySelectorAll('#termine, #warteliste');
    var stand = {};
    ziele.forEach(function(z, i){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ stand[i] = e.isIntersecting; });
        zielSichtbar = Object.keys(stand).some(function(k){ return stand[k]; });
        setze();
      }, {threshold:.05}).observe(z);
    });
  }

  

  var hlsGeht = false;
  try { hlsGeht = !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl'); } catch (e) {}
  var shopVideo = /^(?:https?:)?\/\/cdn\.shopify\.com\/videos\/c\/vp\/([0-9a-f]{32})\/\1\.[^\/?#]+\.mp4/;
  var quelleFuer = function(url){
    var m = shopVideo.exec(url || '');
    if (!m) return url;
    if (hlsGeht) return url.slice(0, url.lastIndexOf('/') + 1) + m[1] + '.m3u8';
    if (matchMedia('(max-width: 900px)').matches) return url.replace('.HD-1080p-2.5Mbps-', '.HD-720p-1.6Mbps-');
    return url;
  };
  var uhrzeit = function(s){
    s = Math.max(0, Math.floor(s || 0));
    return Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2);
  };
  var IC = {
    play:  '<svg class="mp-ic-play" viewBox="0 0 24 24" aria-hidden="true"><path d="M7.5 4.6v14.8L19.4 12z"/></svg>',
    pause: '<svg class="mp-ic-pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M6.6 4.6h3.6v14.8H6.6zM13.8 4.6h3.6v14.8h-3.6z"/></svg>',
    laut:  '<svg class="mp-ic-laut" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 9.2h3.6L12 5v14l-4.9-4.2H3.5z"/><path class="linie" d="M15.2 9a4.2 4.2 0 0 1 0 6M17.8 6.4a8 8 0 0 1 0 11.2"/></svg>',
    stumm: '<svg class="mp-ic-stumm" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 9.2h3.6L12 5v14l-4.9-4.2H3.5z"/><path class="linie" d="M15.5 9.5l5 5M20.5 9.5l-5 5"/></svg>',
    voll:  '<svg class="mp-ic-voll" viewBox="0 0 24 24" aria-hidden="true"><path class="linie" d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5"/></svg>',
    klein: '<svg class="mp-ic-klein" viewBox="0 0 24 24" aria-hidden="true"><path class="linie" d="M9 4v5H4M20 9h-5V4M15 20v-5h5M4 15h5v5"/></svg>'
  };
  var vollElement = function(){ return document.fullscreenElement || document.webkitFullscreenElement || null; };

  

  var spieler = function(rahmen, video, opt){
    if (rahmen.__mp) return rahmen.__mp;
    opt = opt || {};
    var quelle0 = video.getAttribute('src') || '';
    var src = video.querySelector('source');
    if (src) quelle0 = src.getAttribute('src') || quelle0;
    var aktuell = '';

    rahmen.classList.add('mp');
    var lade = document.createElement('span');
    lade.className = 'mp-lade';
    lade.setAttribute('aria-hidden', 'true');
    var faden = document.createElement('span');
    faden.className = 'mp-faden';
    faden.setAttribute('aria-hidden', 'true');
    faden.innerHTML = '<i></i>';
    var leiste = document.createElement('div');
    leiste.className = 'mp-leiste';
    leiste.innerHTML =
      '<div class="mp-achse" role="slider" tabindex="0" aria-valuemin="0" aria-valuemax="0" aria-valuenow="0">' +
        '<span class="mp-bahn"><i class="mp-puffer"></i><i class="mp-gespielt"></i><b class="mp-griff"></b></span></div>' +
      '<div class="mp-reihe">' +
        '<button type="button" class="mp-knopf mp-toggle">' + IC.play + IC.pause + '</button>' +
        '<span class="mp-zeit" aria-hidden="true"><span class="mp-jetzt">0:00</span><span class="mp-gesamt"></span></span>' +
        '<button type="button" class="mp-knopf mp-ton">' + IC.laut + IC.stumm + '</button>' +
        '<button type="button" class="mp-knopf mp-voll">' + IC.voll + IC.klein + '</button>' +
      '</div>';
    rahmen.appendChild(lade);
    rahmen.appendChild(faden);
    rahmen.appendChild(leiste);
    var achse = leiste.querySelector('.mp-achse');
    var puffer = leiste.querySelector('.mp-puffer');
    var gespielt = leiste.querySelector('.mp-gespielt');
    var griff = leiste.querySelector('.mp-griff');
    var fadenI = faden.querySelector('i');
    var jetzt = leiste.querySelector('.mp-jetzt');
    var gesamt = leiste.querySelector('.mp-gesamt');
    var knopf = leiste.querySelector('.mp-toggle');
    var ton = leiste.querySelector('.mp-ton');
    var voll = leiste.querySelector('.mp-voll');
    achse.setAttribute('aria-label', materea_t("js.ws.position_im_video"));
    knopf.setAttribute('aria-label', materea_t("js.pdp.video_pausieren"));
    ton.setAttribute('aria-label', materea_t("js.pdp.ton_aus"));
    voll.setAttribute('aria-label', materea_t("js.katalog.vollbild"));
    if (!(rahmen.requestFullscreen || rahmen.webkitRequestFullscreen || video.webkitEnterFullscreen)) voll.hidden = true;

    var uhr, ziehtGerade = false, gestartet = false;
    var zeigen = function(){
      rahmen.classList.add('zeigt');
      clearTimeout(uhr);
      if (video.paused || ziehtGerade) return;
      uhr = setTimeout(function(){
        if (!leiste.contains(document.activeElement)) rahmen.classList.remove('zeigt');
      }, 2500);
    };
    var verstecken = function(){ clearTimeout(uhr); rahmen.classList.remove('zeigt'); };

    var zeichne = function(){
      var d = video.duration, t = video.currentTime;
      if (!(d > 0) || !isFinite(d)) return;
      var a = Math.min(1, t / d);
      gespielt.style.transform = 'scaleX(' + a + ')';
      fadenI.style.transform = 'scaleX(' + a + ')';
      griff.style.left = (a * 100) + '%';
      jetzt.textContent = uhrzeit(t);
      achse.setAttribute('aria-valuenow', Math.floor(t));
      achse.setAttribute('aria-valuetext', uhrzeit(t) + ' / ' + uhrzeit(d));
    };
    var rafId = 0;
    var schleife = function(){ zeichne(); rafId = video.paused ? 0 : requestAnimationFrame(schleife); };
    var dauerSetzen = function(){
      var d = video.duration;
      if (!(d > 0) || !isFinite(d)) return;
      gesamt.textContent = ' / ' + uhrzeit(d);
      achse.setAttribute('aria-valuemax', Math.floor(d));
      zeichne();
    };
    var pufferSetzen = function(){
      var d = video.duration, b = video.buffered;
      if (!(d > 0) || !isFinite(d) || !b.length) return;
      var ende = 0;
      for (var i = 0; i < b.length; i++) if (b.start(i) <= video.currentTime + .5) ende = Math.max(ende, b.end(i));
      puffer.style.transform = 'scaleX(' + Math.min(1, ende / d) + ')';
    };

    var abspielen = function(){
      var los = video.play();
      if (los && los.catch) los.catch(function(err){
         
        if (err && err.name === 'NotAllowedError' && !video.muted) { video.muted = true; abspielen(); }
      });
    };
    var start = function(url, perTastatur){
      var ziel = quelleFuer(url || quelle0);
      if (ziel && ziel !== aktuell) {
        aktuell = ziel;
        if (src) { src.remove(); src = null; video.src = ziel; }
        else if (ziel !== video.getAttribute('src')) video.src = ziel;
      }
      gestartet = false;
      rahmen.classList.remove('gestartet');
      rahmen.classList.add('spielt', 'laedt');
      zeigen();
      abspielen();
       
      if (perTastatur) knopf.focus({preventScroll:true});
    };
    var halt = function(){ if (!video.paused) video.pause(); };

     
    video.addEventListener('error', function(){
      var orig = quelle0;
      if (aktuell && orig && aktuell !== orig) {
        aktuell = orig;
        video.src = orig;
        abspielen();
      } else {
        rahmen.classList.remove('laedt');
      }
    });
    video.addEventListener('waiting', function(){ rahmen.classList.add('laedt'); });
     
    video.addEventListener('playing', function(){ gestartet = true; rahmen.classList.remove('laedt'); rahmen.classList.add('gestartet'); });
    video.addEventListener('canplay', function(){ if (!video.paused) rahmen.classList.remove('laedt'); });
    video.addEventListener('loadedmetadata', dauerSetzen);
    video.addEventListener('durationchange', dauerSetzen);
    video.addEventListener('progress', pufferSetzen);
    video.addEventListener('timeupdate', function(){ pufferSetzen(); if (!rafId) zeichne(); });
    

    video.addEventListener('play', function(){
      document.documentElement.classList.add('mp-laeuft');
      rahmen.classList.remove('pausiert');
      knopf.setAttribute('aria-label', materea_t("js.pdp.video_pausieren"));
      if (!rafId) rafId = requestAnimationFrame(schleife);
      zeigen();
    });
    video.addEventListener('pause', function(){
      document.documentElement.classList.remove('mp-laeuft');
      rahmen.classList.add('pausiert');
      rahmen.classList.remove('laedt');
      knopf.setAttribute('aria-label', materea_t("js.pdp.video_abspielen"));
      zeigen();
    });
    video.addEventListener('volumechange', function(){
      rahmen.classList.toggle('stumm', video.muted);
      ton.setAttribute('aria-label', video.muted ? materea_t("js.pdp.ton_ein") : materea_t("js.pdp.ton_aus"));
    });
    video.addEventListener('ended', function(){
      if (vollElement() === rahmen) (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      rahmen.classList.remove('spielt', 'zeigt', 'pausiert', 'laedt', 'gestartet');
      video.currentTime = 0;
      zeichne();
      if (opt.ende) opt.ende();
    });

    knopf.addEventListener('click', function(){ video.paused ? abspielen() : video.pause(); });
    ton.addEventListener('click', function(){ video.muted = !video.muted; zeigen(); });
    voll.addEventListener('click', function(){
      if (vollElement()) {
        (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      } else if (rahmen.requestFullscreen) {
        rahmen.requestFullscreen().catch(function(){});
      } else if (rahmen.webkitRequestFullscreen) {
        rahmen.webkitRequestFullscreen();
      } else if (video.webkitEnterFullscreen) {
         
        video.webkitEnterFullscreen();
      }
    });
    var vollWechsel = function(){
      var drin = vollElement() === rahmen;
      rahmen.classList.toggle('im-vollbild', drin);
      voll.setAttribute('aria-label', drin ? materea_t("js.ws.vollbild_beenden") : materea_t("js.katalog.vollbild"));
      zeigen();
    };
    document.addEventListener('fullscreenchange', vollWechsel);
    document.addEventListener('webkitfullscreenchange', vollWechsel);

    

    var zeiger = 'mouse';
    video.addEventListener('pointerdown', function(e){ zeiger = e.pointerType || 'mouse'; });
    video.addEventListener('click', function(){
      if (!rahmen.classList.contains('spielt')) return;
      if (!gestartet && rahmen.classList.contains('laedt')) { zeigen(); return; }
      if (zeiger !== 'mouse' && !rahmen.classList.contains('zeigt')) { zeigen(); return; }
      video.paused ? abspielen() : video.pause();
    });
    rahmen.addEventListener('pointermove', function(e){ if (e.pointerType === 'mouse' && rahmen.classList.contains('spielt')) zeigen(); });
    

    rahmen.addEventListener('pointerleave', function(e){ if (e.pointerType === 'mouse' && !video.paused && !ziehtGerade) verstecken(); });
    leiste.addEventListener('focusin', zeigen);

    

    var box = null, warSpielend = false;
    var anteil = function(e){ return Math.max(0, Math.min(1, (e.clientX - box.left) / box.width)); };
    var setzeZeit = function(a){
      if (!(video.duration > 0) || !isFinite(video.duration)) return;
      video.currentTime = a * video.duration;
      zeichne();
    };
    achse.addEventListener('pointerdown', function(e){
      if (e.button > 0) return;
      box = achse.querySelector('.mp-bahn').getBoundingClientRect();
      ziehtGerade = true;
      warSpielend = !video.paused;
      achse.classList.add('zieht');
      if (achse.setPointerCapture) achse.setPointerCapture(e.pointerId);
      setzeZeit(anteil(e));
      zeigen();
      e.preventDefault();
    });
    achse.addEventListener('pointermove', function(e){ if (ziehtGerade) setzeZeit(anteil(e)); });
    var loslassen = function(){
      if (!ziehtGerade) return;
      ziehtGerade = false;
      achse.classList.remove('zieht');
      if (warSpielend && video.paused) abspielen();
      zeigen();
    };
    achse.addEventListener('pointerup', loslassen);
    achse.addEventListener('pointercancel', loslassen);
    achse.addEventListener('keydown', function(e){
      var d = video.duration;
      if (!(d > 0)) return;
      var t = video.currentTime, neu = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') neu = t + 5;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') neu = t - 5;
      else if (e.key === 'PageUp') neu = t + 15;
      else if (e.key === 'PageDown') neu = t - 15;
      else if (e.key === 'Home') neu = 0;
      else if (e.key === 'End') neu = d - .1;
      if (neu === null) return;
      e.preventDefault();
      setzeZeit(Math.max(0, Math.min(d, neu)) / d);
      zeigen();
    });
    rahmen.addEventListener('keydown', function(e){
      if (!rahmen.classList.contains('spielt') || e.target === achse) return;
      if (e.target.tagName === 'BUTTON' && (e.key === ' ' || e.key === 'Enter')) return;
      if (e.key === ' ' || e.key === 'k') { e.preventDefault(); video.paused ? abspielen() : video.pause(); }
      else if (e.key === 'm') ton.click();
      else if (e.key === 'f') voll.click();
    });

     
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.intersectionRatio < .35 && !video.paused && vollElement() !== rahmen) {
            video.pause();
            if (opt.weg) opt.weg();
          }
        });
      }, {threshold:[0, .35]}).observe(rahmen);
    }

    rahmen.__mp = {start: start, halt: halt, video: video};
    return rahmen.__mp;
  };
  window.__matereaSpieler = spieler;

  

  var sparen = !!(navigator.connection && navigator.connection.saveData);
  var vorschau = function(traeger, schleife, gesperrt){
    if (!schleife || statisch || reduziert || sparen) {
      if (schleife) { schleife.removeAttribute('autoplay'); schleife.pause(); schleife.preload = 'none'; }
      return null;
    }
    var sichtbar = true;
    var anwerfen = function(){
      if (!sichtbar || document.hidden || (gesperrt && gesperrt())) return;
      var los = schleife.play();
      if (los && los.catch) los.catch(function(){});
    };
    var zeigen = function(){ traeger.classList.add('vorschau'); anwerfen(); };
    if (schleife.readyState >= 3) zeigen();
    else schleife.addEventListener('canplay', zeigen, {once:true});
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          sichtbar = e.isIntersecting;
          sichtbar ? anwerfen() : schleife.pause();
        });
      }, {threshold:.15}).observe(traeger);
    }
    document.addEventListener('visibilitychange', function(){ document.hidden ? schleife.pause() : anwerfen(); });
    return anwerfen;
  };

   
  var stimmen = document.querySelectorAll('[data-ws-video]');
  stimmen.forEach(function(karte){
    var video = karte.querySelector('video[data-ws-haupt]') || karte.querySelector('video');
    var deckel = karte.querySelector('.deckel');
    if (!video || !deckel) return;
    var schleife = karte.querySelector('[data-ws-schleife]');
    var wieder = vorschau(karte, schleife, function(){ return karte.classList.contains('spielt'); });
    var mp = spieler(karte, video, {ende: function(){ if (wieder) wieder(); }});

    

    var dauer = karte.querySelector('[data-ws-dauer]');
    if (dauer) {
      video.addEventListener('loadedmetadata', function(){
        var d = Math.round(video.duration);
        if (isFinite(d) && d > 0) dauer.textContent = uhrzeit(d);
      }, {once:true});
      var metadaten = function(){
        if (video.readyState > 0 || karte.classList.contains('spielt') || sparen) return;
        video.preload = 'metadata';
        video.load();
      };
      if (document.readyState === 'complete') metadaten();
      else window.addEventListener('load', metadaten, {once:true});
    }

    deckel.addEventListener('click', function(e){
      if (schleife) schleife.pause();
      mp.start(null, e.detail === 0);
    });
  });

   
  var ws6Traeger = document.querySelector('[data-ws-schleife-traeger]');
  if (ws6Traeger) vorschau(ws6Traeger, ws6Traeger.querySelector('[data-ws-schleife]'));

   
  var wahl = document.querySelector('[data-ws-terminwahl]');
  var terminParam = p.get('termin');
  if (wahl && terminParam) {
    for (var i = 0; i < wahl.options.length; i++) {
      if (wahl.options[i].value === terminParam) {
        wahl.selectedIndex = i;
        var ws9 = document.getElementById('warteliste');
        if (ws9 && !location.hash) ws9.scrollIntoView();
        break;
      }
    }
  }

  

  var form = document.querySelector('[data-ws-warteliste]');
  if (form && !form.hasAttribute('data-ws-gebunden')) {
    form.setAttribute('data-ws-gebunden', '');
    form.addEventListener('submit', function(ev){
      ev.preventDefault();
      var fehler = form.querySelector('[data-ws-fehler]');
      fehler.hidden = true;
      if (!form.reportValidity()) return;
      var ep = form.getAttribute('data-endpoint');
      var daten = {};
      new FormData(form).forEach(function(v, k){ daten[k] = v; });
      daten.formular = 'warteliste';
      daten.aktion = 'workshop_warteliste';
      if (/^\d+$/.test(daten.wunschtermin || '')) daten.termin_id = daten.wunschtermin;
      daten.format = form.getAttribute('data-format') || '';
      if (!ep) {
        fehler.textContent = materea_t("js.ws.warteliste_weg");
        fehler.hidden = false;
        return;
      }
      var knopf = form.querySelector('.ws9-cta');
      knopf.disabled = true;
      fetch(ep, {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(daten)})
        .then(function(r){ if (!r.ok) throw new Error('status ' + r.status); return r.json().catch(function(){ return {}; }); })
        .then(function(){
          form.hidden = true;
          var danke = document.querySelector('[data-ws-danke]');
          danke.querySelector('[data-ws-danke-mail]').textContent = daten.email;
          danke.hidden = false;
        })
        .catch(function(){
          fehler.textContent = materea_t("js.ws.fehler");
          fehler.hidden = false;
          knopf.disabled = false;
        });
    });
  }
})();

(function(){
  

  if (window.__matereaWsStimmen) return;
  window.__matereaWsStimmen = 1;
   
  var huelle = document.querySelector('.wsst-huelle');
  var bahn   = huelle && huelle.querySelector('.wsst-bahn');
  if (bahn) {
    var balken = huelle.querySelector('.wsst-fortschritt i');
    var zur    = huelle.querySelector('[data-ws-zurueck]');
    var vor    = huelle.querySelector('[data-ws-vor]');

    var schritt = function(){
      var k = bahn.querySelector('.wsst-karte');
      if (!k) return bahn.clientWidth;
      var gap = parseFloat(getComputedStyle(bahn).columnGap) || 0;
      return k.getBoundingClientRect().width + gap;
    };

    var zeichne = function(){
      var max = bahn.scrollWidth - bahn.clientWidth;
      var scrollt = max > 1;
      huelle.classList.toggle('scrollt', scrollt);
      if (!scrollt) return;
      var anteil = bahn.clientWidth / bahn.scrollWidth;
      balken.style.setProperty('--anteil', (anteil * 100) + '%');
      balken.style.setProperty('--los', ((bahn.scrollLeft / max) * (100 / anteil - 100)) + '%');
      huelle.style.setProperty('--kante', bahn.scrollLeft >= max - 2 ? 0 : 1);
      zur.disabled = bahn.scrollLeft <= 1;
      vor.disabled = bahn.scrollLeft >= max - 1;
    };

    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    zur.addEventListener('click', function(){ bahn.scrollBy({left:-schritt(), behavior: ruhig?'auto':'smooth'}); });
    vor.addEventListener('click', function(){ bahn.scrollBy({left: schritt(), behavior: ruhig?'auto':'smooth'}); });
    bahn.addEventListener('scroll', zeichne, {passive:true});
    window.addEventListener('resize', zeichne);
    if (document.readyState === 'complete') zeichne();
    else window.addEventListener('load', zeichne);
    zeichne();
  }

  

  var spieler = window.__matereaSpieler;
  var overlay = document.querySelector('[data-ws-overlay]');
  if (overlay && spieler) {
    var filmVideo = overlay.querySelector('[data-ws-spieler]');
    var filmRahmen = overlay.querySelector('[data-ws-spieler-rahmen]') || filmVideo.parentNode;
    var untertitel = overlay.querySelector('[data-ws-untertitel]');
    var zuKnopf = overlay.querySelector('[data-ws-zu]');
    var zurueckZu = null;
    var schliessen = function(){
      if (!overlay.hasAttribute('open')) return;
      filmVideo.pause();
      overlay.removeAttribute('open');
      document.body.style.overflow = '';
      if (zurueckZu) { zurueckZu.focus(); zurueckZu = null; }
    };
    var film = spieler(filmRahmen, filmVideo, {ende: schliessen});
    var oeffnen = function(quelle, titel, ausloeser){
      zurueckZu = ausloeser;
      untertitel.textContent = titel || '';
      overlay.setAttribute('open','');
      document.body.style.overflow = 'hidden';
      zuKnopf.focus();
      film.start(quelle, false);
    };
    document.querySelectorAll('.wsst-film .deckel[data-ws-quelle]').forEach(function(knopf){
      knopf.addEventListener('click', function(){
        oeffnen(knopf.getAttribute('data-ws-quelle'), knopf.getAttribute('data-ws-titel'), knopf);
      });
    });
    zuKnopf.addEventListener('click', schliessen);
    overlay.addEventListener('click', function(e){ if (e.target === overlay) schliessen(); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !(document.fullscreenElement || document.webkitFullscreenElement)) schliessen();
    });
  }

  

  var karten = [].slice.call(document.querySelectorAll('.wsst-karte'));
  karten.forEach(function(karte){
    var v = karte.querySelector('.wsst-video');
    var deckel = karte.querySelector('.deckel');
    if (!v || !deckel || !spieler) return;
    var titel = deckel.getAttribute('data-ws-titel') || 'Video';
    var zurueck = function(){
      karte.classList.remove('is-playing', 'spielt', 'zeigt', 'pausiert', 'laedt', 'gestartet');
      deckel.setAttribute('aria-label', materea_t("js.ws.video_abspielen") + titel);
    };
    var mp = spieler(karte, v, {ende: zurueck, weg: zurueck});
    deckel.addEventListener('click', function(e){
      karte.classList.add('is-playing');
      deckel.setAttribute('aria-label', materea_t("js.ws.video_pausieren") + titel);
      mp.start(null, e.detail === 0);
    });
  });

  

  document.addEventListener('play', function(e){
    var laeuft = e.target;
    document.querySelectorAll('video').forEach(function(v){
      if (v !== laeuft && !v.paused && !v.hasAttribute('data-ws-schleife')) v.pause();
    });
  }, true);
})();
